import { ASSETS_DOMAIN, STAGE_ASSETS_DOMAIN } from '~~/constants/images';
import { isProduction } from '~~/helpers/env/checkEnvironmentType';

/**
 * Origin serving product and CMS images for the current deployment: production
 * uses `assets.expondo.com`, every other environment (stage, dev, local) uses
 * `assets-stage.expondo.com`.
 *
 * Call this at request time only — never from `nuxt.config.ts` or any module
 * scope that is evaluated while building. `APPLICATION_ENVIRONMENT` is a runtime
 * variable (see `NUXT_PUBLIC_APPLICATION_ENVIRONMENT` in `azure/*\/app.yaml`), so
 * a build-time read would bake one environment's origin into the bundle.
 */
export const getAssetsOrigin = (): string => {

  const domain = isProduction() ? ASSETS_DOMAIN : STAGE_ASSETS_DOMAIN;

  return `https://${domain}`;

};
